/**********************************************************************
*
*   Component hook generated by Quest
*
*   Code Logic for the component goes in this hook
*   To setup bindings that use the data here or call the functions here, use the Quest editor   
*
*   For help and further details refer to: https://www.quest.ai/docs
*
*
**********************************************************************/

import { useState } from "react";

const useSidebarRow = () => {
  let [isHover, setisHover] = useState(false);
  let data = { isHover };

  const handleMouseOver = () => {
    setisHover(true);
  };

  const handleMouseOut = () => {
    setisHover(false);
  };

  let fns = { handleMouseOver, handleMouseOut };
  return { data, fns };
}

export default useSidebarRow;